export class RedBloodCellSize {
    static NORMAL = new RedBloodCellSize({ type: 'Normocytic', name: 'Normal' });
    static SMALL = new RedBloodCellSize({ type: 'Microcytic', name: 'Small' });
    static LARGE = new RedBloodCellSize({ type: 'Macrocytic', name: 'Large' });
    static NOT_APPLICABLE = new RedBloodCellSize({ type: 'N/A', name: 'N/A' });

    type: string;
    name: string;

    constructor(redBloodCellSize?: RedBloodCellSize) {
        // This handles copying the simple properties
        if (!redBloodCellSize) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(redBloodCellSize).forEach(key => {
            this[key] = redBloodCellSize[key];
        });
    }
}
